import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Table } from 'foundations-components/transitional/components/Table';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { PaidUsersFeatureCells } from './PaidUsersFeatureCells';
import { usePaidUsersModal } from './usePaidUsersModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const titleCopyMap = {
  SALES_PRODUCTS: {
    STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.title.SALES.STARTER"
    }),
    PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.title.SALES.PROFESSIONAL"
    }),
    ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.title.SALES.ENTERPRISE"
    })
  },
  SERVICE_HUB_PRODUCTS: {
    STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.title.SERVICE.STARTER"
    }),
    PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.title.SERVICE.PROFESSIONAL"
    }),
    ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.title.SERVICE.ENTERPRISE"
    })
  }
};
export const PaidUsersFeatureTable = ({
  productLevel,
  skuCategoryName
}) => {
  const {
    features,
    paidProductLevels,
    productMap
  } = usePaidUsersModal({
    skuCategoryName
  });
  if (paidProductLevels.length) {
    return /*#__PURE__*/_jsx(Tabs, {
      use: "enclosed",
      defaultSelected: productLevel,
      fill: true,
      children: paidProductLevels.map(level => {
        var _titleCopyMap$skuCate;
        return /*#__PURE__*/_jsxs(Tab, {
          tabId: level,
          title: (_titleCopyMap$skuCate = titleCopyMap[skuCategoryName]) === null || _titleCopyMap$skuCate === void 0 ? void 0 : _titleCopyMap$skuCate[level],
          children: [/*#__PURE__*/_jsxs(Table, {
            tableLayout: "fixed",
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsx("tr", {
                children: /*#__PURE__*/_jsxs("th", {
                  colSpan: 2,
                  children: [/*#__PURE__*/_jsx(View, {
                    marginBlockEnd: "200",
                    children: /*#__PURE__*/_jsx(Text, {
                      as: "h3",
                      typography: "heading-50",
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.table.paidUsersOnlyTitle"
                      })
                    })
                  }), /*#__PURE__*/_jsx(Text, {
                    textTransform: "none",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.table.paidUsersOnlySubtitle"
                    })
                  })]
                })
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: /*#__PURE__*/_jsx(PaidUsersFeatureCells, {
                level: level,
                requiresPaidSeat: true,
                features: features,
                productMap: productMap
              })
            })]
          }), /*#__PURE__*/_jsxs(Table, {
            tableLayout: "fixed",
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsx("tr", {
                children: /*#__PURE__*/_jsxs("th", {
                  colSpan: 2,
                  children: [/*#__PURE__*/_jsx(View, {
                    marginBlockEnd: "200",
                    children: /*#__PURE__*/_jsx(Text, {
                      as: "h3",
                      typography: "heading-50",
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.table.freeUsersTitle"
                      })
                    })
                  }), /*#__PURE__*/_jsx(Text, {
                    textTransform: "none",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsersModal.table.freeUsersSubtitle"
                    })
                  })]
                })
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: /*#__PURE__*/_jsx(PaidUsersFeatureCells, {
                level: level,
                requiresPaidSeat: false,
                features: features,
                productMap: productMap
              })
            })]
          })]
        }, level);
      })
    });
  }
  return null;
};